export const DataTestID = {
  LayoutBuilder: 'layout-builder',
  LayoutBuilderGridCell: 'layout-builder-grid-cell',
  LayoutBuilderGridSection: 'layout-builder-grid-section',
  LayoutListCard: 'layout-list-card',
  LayoutEditSidebarDefaultLayoutDrawer: 'default-layout-drawer',
  LayoutEditSidebarScreenRotationDrawer: 'screen-rotations-drawer',
  LayoutEditSidebarTakeoverDrawer: 'takeover-drawer',
  LayoutEditSidebarTakeoverLock: 'takeover-lock-icon',
  LocationSchedulePageTable: 'location-schedule-page-table',
  LocationSchedulePageTableHead: 'location-schedule-page-table-head',
  LocationSchedulePageTableCell: 'location-schedule-page-table-cell',
  LocationSchedulePageTableSortIcon: 'location-schedule-page-table-sort-icon',
  LocationSchedulePageTableArrowIcon: 'location-schedule-page-table-arrow-icon',
  LocationSchedulePageTableBody: 'location-schedule-page-table-body',
  LocationSchedulePageTableDeleteMenu:
    'location-schedule-page-table-delete-menu',
  AssemblyPublicationSavedTab: 'assembly-publication-saved-tab',
  SubHeaderWithSortingStyledLabel: 'sub-header-with-sorting-styled-label',
  SubHeaderWithPageStyledLabel: 'sub-header-with-page-styled-label',
  CoatesLoginButton: 'coates-login-button',
  Auth0LockContainer: 'auth0-lock-container',
  Auth0LockContainerError: 'auth0-lock-container-error',
  CustomButton: 'custom-button',
  CustomTable: 'custom-table',
  CustomTableWithPagination: 'custom-table-with-pagination',
  ManageComponentTagUpArrowIcon: 'manage-component-tag-up-arrow-icon',
  ManageComponentTagDownArrowIcon: 'manage-component-tag-down-arrow-icon',
  ManageAssemblyTagUpArrowIcon: 'manage-assembly-tag-up-arrow-icon',
  ManageAssemblyTagDownArrowIcon: 'manage-assembly-tag-down-arrow-icon',
  AddComponentTagComponentData: 'add-component-tag-component-data',
  AddAssemblyTagAssemblyData: 'add-assembly-tag-assembly-data',
  ManageAssemblyDeleteButton: 'manage-assembly-delete-button',
  ManageComponentDeleteButton: 'manage-component-delete-button',
  DetailComponentMenuIcon: 'detail-component-menu-icon',
  DetailComponentDuplicateName: 'detail-component-duplicate-name',
  Loading: 'loading',
  SearchBarLoading: 'search-bar-loading',
  CustomChip: 'custom-chip',
  ExactMatchToggle: 'exact-match-toggle',
  ComponentTagCount: 'component-tag-count',
};
